// Custom dot component for predicted emotion
export const EmotionScatterChartPredictedDot = (props: any) => {
  const { cx, cy } = props

  if (!cx || !cy) return <g />

  // Star points
  const points = []
  const outerRadius = 8
  const innerRadius = 4
  const numPoints = 5

  for (let i = 0; i < numPoints * 2; i++) {
    const radius = i % 2 === 0 ? outerRadius : innerRadius
    const angle = (i * Math.PI) / numPoints
    const x = cx + radius * Math.cos(angle - Math.PI / 2)
    const y = cy + radius * Math.sin(angle - Math.PI / 2)
    points.push(`${x},${y}`)
  }

  return (
    <g>
      {/* Star shape */}
      <polygon
        points={points.join(' ')}
        fill="hsl(276, 70%, 60%)"
        stroke="hsl(276, 90%, 80%)"
        strokeWidth={2}
      />
    </g>
  )
}

export const EmotionScatterChartLegendContent = (props: any) => {
  const { payload } = props
  return (
    <ul className="flex justify-center mb-2 text-sm">
      {payload
        ?.filter((entry: any) => entry.value === 'Predicted Emotion')
        .map((entry: any, index: number) => (
          <li key={`item-${index}`} className="flex items-center gap-2">
            {entry.value === 'Predicted Emotion' ? (
              <svg width="16" height="16" viewBox="0 0 16 16">
                <polygon
                  points="8,1 10,6 15,6 11,10 13,15 8,12 3,15 5,10 1,6 6,6"
                  fill="hsl(276, 70%, 60%)"
                  stroke="hsl(276, 90%, 80%)"
                  strokeWidth="1"
                />
              </svg>
            ) : (
              <div className="w-3 h-3 rounded-full bg-blue-600"></div>
            )}
            <span className="text-gray-700">
              {entry.value} (<span className="font-bold">Valence</span>:{' '}
              {entry.payload.data[0].x.toFixed(1)},{' '}
              <span className="font-bold">Arousal</span>:{' '}
              {entry.payload.data[0].y.toFixed(1)})
            </span>
          </li>
        ))}
    </ul>
  )
}
